import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, Fragment as _Fragment } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.IsShwoBtn && _ctx.typebtn !== 'text')
      ? (_openBlock(), _createBlock(_component_a_button, {
          key: 0,
          onClick: _ctx.openModal,
          type: _ctx.typebtn
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.btnName), 1)
          ]),
          _: 1
        }, 8, ["onClick", "type"]))
      : _createCommentVNode("", true),
    (_ctx.IsShwoBtn && _ctx.typebtn == 'text')
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          href: "javascript:void(0);",
          type: "link",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args))),
          class: "theme-color",
          style: { color: '#2F7BFF'}
        }, _toDisplayString(_ctx.btnName), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      centered: true,
      keyboard: false,
      "mask-closable": false,
      visible: _ctx.visible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visible) = $event)),
      title: _ctx.btnName,
      "ok-text": "确认",
      "cancel-text": "取消",
      onOk: _ctx.ok
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          layout: "vertical",
          model: _ctx.formModel,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  placeholder: _ctx.placeholder,
                  value: _ctx.formModel.remark,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formModel.remark) = $event)),
                  showCount: "",
                  rows: 4,
                  maxlength: 200
                }, null, 8, ["placeholder", "value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible", "title", "onOk"])
  ], 64))
}